import { PolicyFlowClosing } from 'src/types'

export default function sanitize(values: PolicyFlowClosing) {
  try {
    const sanitized = JSON.parse(JSON.stringify(values))
    delete sanitized.key
    sanitized.policy_closing_id = +values.policy_closing_id || null
    return sanitized
  } catch (err) {
    //send bugsnag
  }
}
